export default {
    SET_SNACKBAR(state, payload) {
        state.snackbar = payload;
    },
    SET_TITLE(state, payload) {
        state.title = payload;
    },
}